// Module
var code = "<div class=\"fc-catalog-container\"></div>";
// Exports
module.exports = code;